export default "__VITE_ASSET__BVy4pkFz__"